<template>
  <div class="layout">
    <div class="box-titulo">Gestión de Flotas / Vehículos</div>
    <div class="box-container">
      <div class="box-filtres">
        <table width="100%">
          <tbody>
            <tr>
              <td width="30%">
                <Select2 v-model="cliente" :options="clientes" @select="actualizaEstructura()" />
              </td>
              <td>
                <button class="btn bg-kubber btn-default" v-on:click="actualizaEstructura" v-if="cliente.length != 0">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>
                <button class="btn btn-secondary" v-on:click="openFlota" v-if="cliente.length != 0">
                  <i class="fa-solid fa-object-group"></i> Crear Flota
                </button>
              </td>
              <td width="5px">
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flota-empresa-titulo">
        {{ cliente_nombres }} / FLOTAS
      </div>

      <div class="bg-cars">
        <div v-for="item in flotas" :key="item">
          <div class="card card-default color-palette-box">
            <div class="card-flota-header" :class="item.activo ? 'card-flota-activa' : ''">
              <table width="100%">
                <tbody>
                  <tr>
                    <td>
                      <div style="font-weight: bold">
                        {{ item.descripcion }}
                      </div>
                      <div style="font-size: 10px; margin-top: -5px">
                        <div v-if="item.forma_pago == 1">CONTADO</div>
                        <div v-else>
                          CREDITO: {{ item.credito_tipo }}-{{
                            GLOBAL.CREDITO_OPERACION[item.credito_tipo]
                          }}
                        </div>
                      </div>
                    </td>
                    <td width="5px">
                      <span v-if="item.activo" class="badge badge-success">ACTIVO</span>
                      <span v-if="!item.activo" class="badge badge-secondary">
                        INACTIVO
                      </span>
                    </td>
                    <td width="5px">
                      <div class="btn-group">
                        <button class="btn btn-sm bg-blue" v-on:click="editarFlota(item)">
                          <i class="fa-solid fa-pencil"></i>
                        </button>

                        <button v-if="item.activo" class="btn btn-sm btn-warning" v-on:click="inactivaFlota(item)">
                          <i class="fa-solid fa-trash"></i>
                        </button>

                        <button v-if="!item.activo" class="btn btn-sm bg-kubber" v-on:click="activarFlota(item)">
                          <i class="fa-solid fa-check"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-flota-body">
              <div class="row">
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-4 col-md-2" v-for="veh in item.vehiculos" :key="veh">
                      <div class="card-vehicle">
                        <div class="card-veh-title">{{ veh.placa }}</div>
                        <div class="card-veh-text">{{ veh.idroom }}&nbsp;</div>
                        <div class="text-right">
                          <div class="btn-group">
                            <button type="button" class="btn btn-default btn-xs" v-on:click="openVehiculo(item, veh)">
                              <i class="fa-solid fa-pencil"></i>
                            </button>
                            <button type="button" class="btn btn-default btn-xs"
                              v-on:click="removeVehiculoFromFlota(item, veh)">
                              <i class="fa-solid fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card-flota-cupo">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr>
                          <td colspan="2" class="text-right">
                            {{ item.forma_pago == "1" ? "CONTADO" : "CREDITO" }}
                          </td>
                        </tr>

                        <tr>
                          <td colspan="2" class="text-right">
                            <span>
                              {{ GLOBAL.DOCUMENTO_ID[item.documento_id] }}
                            </span>
                          </td>
                        </tr>

                        <tr v-if="item.flota_precio > 0">
                          <td>PRECIO ESPECIAL</td>
                          <td class="text-right">$ {{ item.flota_precio }}</td>
                        </tr>

                        <tr v-if="item.descuento_valor > 0">
                          <td>DESCUENTO</td>
                          <td class="text-right">
                            <span v-if="item.descuento_tipo == 1">
                              {{
                                GLOBAL.FORMATO_MONEY_BASIC(item.descuento_valor)
                              }}
                            </span>
                            <span v-if="item.descuento_tipo == 2">
                              {{ GLOBAL.FORMATO_NUMBER(item.descuento_valor) }}
                              %
                            </span>
                          </td>
                        </tr>
                        
                        <tr v-if="item.forma_pago == 2">
                          <td>TIPO CREDITO</td>
                          <td class="text-right">
                            {{ GLOBAL.CREDITO_OPERACION[item.credito_tipo] }}
                          </td>
                        </tr>

                        <tr v-if="item.forma_pago == 2 && item.credito_tipo == 3">
                          <td>CUPO</td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(
                                item.credito_cupo_maximo
                              )
                            }}
                          </td>
                        </tr>

                        <tr v-if="item.forma_pago == 2 && item.credito_tipo == 3">
                          <td>CONSUMIDO</td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(
                                item.credito_consumo_actual
                              )
                            }}
                          </td>
                        </tr>

                        <tr v-if="item.forma_pago == 2 && item.credito_tipo == 3">
                          <td>SALDO</td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(
                                item.credito_cupo_maximo -
                                item.credito_consumo_actual
                              )
                            }}
                          </td>
                        </tr>

                        <tr v-if="item.forma_pago == 2">
                          <td>DIAS</td>
                          <td class="text-right">
                            {{ item.restriccion_dias }}
                          </td>
                        </tr>

                        <tr v-if="item.forma_pago == 2">
                          <td>VISITAS</td>
                          <td class="text-right">
                            {{ item.restriccion_visitas }} Veces
                          </td>
                        </tr>

                        <tr>
                          <td>VEHÍCULOS</td>
                          <td class="text-right">
                            {{ item.vehiculos.length }}
                          </td>
                        </tr>
                        
                        <tr>
                          <td colspan="2" class="text-right">
                            <button class="btn btn-xs btn-primary" v-on:click="openVehiculo(item, null)">
                              <i class="fa-solid fa-pencil"></i> Agregar
                              Vehiculo
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL FLOTAS -->
    <div class="modal" tabindex="-1" :class="{ 'is-active': showModalFlota }">
      <div class="modal-background" @click="closeModalFlota"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">Agregar/Modificar Flota</div>
          <div class="modal-body">
            <table width="90%" class="center">
              <tbody>
                <tr>
                  <td>{{ cliente.nombres }} / FLOTA:</td>
                </tr>
                <tr>
                  <td>
                    <input v-model="flota.descripcion" class="form-control" style="text-transform: uppercase" />
                  </td>
                </tr>
              </tbody>
            </table>

            <table width="90%" class="center">
              <tbody>
                <tr>
                  <td>DOCUMENTO A GENERAR</td>
                </tr>
                <tr>
                  <td colspan="2" style="font-size: 11px; text-align: center">

                    <select class="form-control" v-model="flota.forma_pago" @change="formaPagoCambiada">
                      <option value="1">CONTADO</option>
                      <option value="2">CREDITO</option>
                    </select>
 
                  </td>
                </tr>
              </tbody>
            </table>

            <table width="90%" class="center" v-if="flota.forma_pago == '2'">
              <tbody>
                <tr>
                  <td colspan="2">TIPO DE CREDITO:</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <select class="form-control" v-model="flota.credito_tipo">
                      <option value="1">CREDITO LIBRE</option>
                      <option value="2">CREDITO CUPO CLIENTE</option>
                      <!--<option value=3>CREDITO CUPO INDEPENDIENTE</option>-->
                    </select>
                  </td>
                </tr>
                <tr v-if="flota.credito_tipo == 3">
                  <td colspan="2">
                    CUPO MÁXIMO DEL CLIENTE:
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="60%">
                            <input v-model="flota.credito_cupo_maximo" class="form-control"
                              style="text-transform: uppercase" />
                          </td>
                          <td class="text-right cupo-saldo">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(
                                flota.credito_cupo_maximo
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    CONSUMO ACTUAL:
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td>
                            <input v-model="flota.credito_consumo_actual" class="form-control"
                              style="text-transform: uppercase" />
                          </td>
                          <td class="text-right cupo-saldo">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(
                                flota.credito_consumo_actual
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    SALDO ESTIMADO:
                    <div class="text-right cupo-saldo">
                      {{
                        GLOBAL.FORMATO_MONEY_BASIC(
                          flota.credito_cupo_maximo -
                          flota.credito_consumo_actual
                        )
                      }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <table width="100%" v-if="false">
              <tbody>
                <tr>
                  <td colspan="2">
                    <br />
                    <div class="text-bold">RESTRICCIONES</div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td colspan="7">
                            DÍAS EN LOS QUE PUEDE CARGAR
                            <!-- Usando DOW de POSTGRES LUNES=1 DOMINGO=0 -->
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chkl" v-model="flota.dia.lunes" />
                              <label for="chkl"> Lu </label>
                            </div>
                          </td>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chkm" v-model="flota.dia.martes" />
                              <label for="chkm"> Ma </label>
                            </div>
                          </td>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chkx" v-model="flota.dia.miercoles" />
                              <label for="chkx"> Mi </label>
                            </div>
                          </td>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chkj" v-model="flota.dia.jueves" />
                              <label for="chkj"> Ju </label>
                            </div>
                          </td>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chkv" v-model="flota.dia.viernes" />
                              <label for="chkv"> Vi </label>
                            </div>
                          </td>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chks" v-model="flota.dia.sabado" />
                              <label for="chks"> Sa </label>
                            </div>
                          </td>
                          <td>
                            <div class="icheck-primary d-inline">
                              <input type="checkbox" id="chkd" v-model="flota.dia.domingo" />
                              <label for="chkd"> Do </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td width="40px">
                            <input v-model="flota.restriccion_visitas" class="form-control"
                              style="text-transform: uppercase" />
                          </td>
                          <td class="pad10">
                            NÚMERO DE VISITAS POR DÍA:<br />
                            <div class="mini-text text-red">
                              Dejar en cero (0) para carga ilimitada
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <div style="width: 90%; margin: auto">
              <div class="text-bold">BENEFICIOS</div>

              <div class="form-check">
                <input class="form-check-input" type="radio" name="radio1" v-model="extra_info" id="descuento_venta"
                  value="1" />
                <label class="form-check-label" for="descuento_venta">
                  DESCUENTO
                </label>

                <div v-if="extra_info == '1'">
                  <div v-if="
                    flota.descuento_tipo == 1 || flota.descuento_tipo == null
                  ">
                    POR CADA UNIDAD (GL/M3/LT)
                  </div>
                  <div v-else>GLOBAL SOBRE FACTURA</div>

                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <select v-model="flota.descuento_tipo" class="form-control">
                            <option value="1">$</option>
                            <option value="2">%</option>
                          </select>
                        </td>
                        <td width="40%">
                          <input v-model="flota.descuento_valor" class="form-control"
                            style="text-transform: uppercase" />
                        </td>
                        <td width="40%">
                          <div v-if="
                            flota.descuento_tipo == 1 ||
                            flota.descuento_tipo == null
                          " class="text-right cupo-saldo">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(flota.descuento_valor)
                            }}
                          </div>
                          <div v-else class="text-right cupo-saldo">
                            {{ GLOBAL.FORMATO_NUMBER(flota.descuento_valor) }} %
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="radio1" v-model="extra_info" id="precio_especial"
                  value="2" />
                <label class="form-check-label" for="precio_especial">PRECIO ESPECIAL</label>

                <div v-if="extra_info == '2'">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="50%">
                          <input type="text" class="form-control" autocomplete="off" style="text-transform: uppercase"
                            v-model="flota.flota_precio" v-on:keypress="GLOBAL.FORMATO_NUMBER" />
                        </td>
                        <td>
                          <div class="text-right cupo-saldo">
                            {{ GLOBAL.FORMATO_MONEY_BASIC(flota.flota_precio) }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="radio1" v-model="extra_info" id="ninguna"
                  value="0" />
                <label class="form-check-label" for="ninguna">Ninguna de las anteriores</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-red">
              {{ flota.mensaje }}
            </div>

            <div v-if="loading">
              <img src="dist/img/kubber-loading.gif" style="width: 30px" />
            </div>

            <button type="button" class="btn bg-gray" v-on:click="closeModalFlota">
              Cerrar
            </button>

            <button type="button" class="btn bg-kubber" :disabled="loading" v-on:click="crearFlota">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL VEHICULOS -->
    <div id="vehiculo" class="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div>AGREGAR VEHICULO EN: {{ flota.descripcion }}</div>
          </div>
          <div class="modal-body pad10">
            <table width="90%" class="center">
              <tbody>
                <tr>
                  <td width="30%" class="text-right pad10-r text-red b">
                    PLACA
                  </td>
                  <td>
                    <table width="100%" class="center">
                      <tbody>
                        <tr>
                          <td>
                            <input type="text" class="form-control" autocomplete="off" v-model="vehiculo.placa"
                              style="text-transform: uppercase" :disabled="bloqueoFormularioVehiculo"
                              v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS" @keyup.enter="getVehiculosPorPlaca" />
                          </td>
                          <td width="1px">
                            <button class="btn btn-info" v-on:click="getVehiculosPorPlaca">
                              <i class="fa-solid fa-magnifying-glass"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td class="text-right pad10-r">iButton</td>
                  <td>
                    <input v-model="vehiculo.idroom" :disabled="bloqueoFormularioVehiculoIbutton" class="form-control"
                      style="text-transform: uppercase" />
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="text-right">
                    <div class="btn-group">
                      <button class="btn btn-outline-primary btn-xs" v-on:click="abrirCambioFlota">
                        <i class="fa-solid fa-list-ul"></i>
                        Cambio de flota
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" v-if="flotaOptions">
                    <select v-model="flotaSelected" class="form-control" v-on:change="actualizaNuevaFlota">
                      <option v-for="item in flotas" :key="item" :value="item">
                        {{ item.descripcion }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 10px" />
            <div style="font-size: 12px; color: slategrey; margin-bottom: 10px">
              <i class="fa-regular fa-address-card"></i> INFORMACIÓN DEL
              PROPIETARIO
            </div>
            <table width="90%" class="center">
              <tbody>
                <tr>
                  <td width="40%">Identificación</td>
                  <td>
                    <input v-model="vehiculo.atributos.propietario_codigo" :disabled="bloqueoFormularioVehiculo"
                      class="form-control" style="text-transform: uppercase" />
                  </td>
                </tr>
                <tr>
                  <td>Nombre completo</td>
                  <td>
                    <input v-model="vehiculo.atributos.propietario_nombre" :disabled="bloqueoFormularioVehiculo"
                      class="form-control" style="text-transform: uppercase" />
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 10px" />
            <div style="font-size: 12px; color: slategrey; margin-bottom: 10px">
              <i class="fa-solid fa-car-side"></i> INFORMACIÓN ADICIONAL DEL
              VEHÍCULO
            </div>

            <table width="90%" class="center">
              <tbody>
                <tr>
                  <td colspan="4">
                    <div>Marca y Linea</div>
                    <input type="text" class="form-control" style="text-transform: uppercase"
                      :disabled="bloqueoFormularioVehiculo" v-model="vehiculo.atributos.marca" />
                  </td>
                </tr>
                <tr>
                  <td>Modelo:</td>
                  <td>
                    <input type="text" v-model="vehiculo.atributos.modelo" class="form-control"
                      :disabled="bloqueoFormularioVehiculo" v-on:keypress="GLOBAL.SOLO_NUMEROS" />
                  </td>
                  <td>Cilindros:</td>
                  <td>
                    <input type="text" v-model="vehiculo.atributos.linea" class="form-control"
                      :disabled="bloqueoFormularioVehiculo" v-on:keypress="GLOBAL.SOLO_NUMEROS" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Capacidad
                    <div style="font-size: 11px">(GLS / LTS)</div>
                  </td>
                  <td>
                    <input type="text" v-model="vehiculo.atributos.litros" class="form-control"
                      :disabled="bloqueoFormularioVehiculo" v-on:keypress="GLOBAL.SOLO_NUMEROS" />
                  </td>
                  <td>Servicio:</td>
                  <td>
                    <select v-model="vehiculo.atributos.tipo_servicio" class="form-control"
                      :disabled="bloqueoFormularioVehiculo">
                      <option selected disabled></option>
                      <option value="publico">PUBLICO</option>
                      <option value="privado">PRIVADO</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 10px" />
            <div style="font-size: 12px; color: slategrey; margin-bottom: 10px">
              <i class="fa-solid fa-car-side"></i> CONTROL DE MANTENIMIENTO
            </div>

            <table width="90%" class="center">
              <tbody>
                <tr>
                  <td width="50%">FECHA CERTIFICACIÓN:</td>
                  <td>
                    <input class="form-control center" type="text" datatype="fecha" autocomplete="off"
                      :disabled="bloqueoFormularioVehiculo" id="fecha_mantenimiento" readonly="true"
                      @change="sumarUnAno" />
                  </td>
                </tr>
                <tr>
                  <td>PRÓXIMA REVISIÓN:</td>
                  <td>
                    <input class="form-control center" type="text" datatype="fecha" autocomplete="off"
                      :disabled="bloqueoFormularioVehiculo" id="fecha_revision" readonly="true" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn bg-gray" data-dismiss="modal">
              Cerrar
            </button>
            <button type="button" class="btn bg-kubber" v-on:click="agregarVehiculoAFlota">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!permiso_lista">
      {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ClienteService from "../../service/ClienteService";
import VehiculoService from "./VehiculoService";
import Select2 from "vue3-select2-component";

export default {
  components: { Select2 },
  data() {
    return {
      GLOBAL,
      loading: true,
      clienteService: null,
      vehiculoService: null,
      clientes: [],
      cliente: [],
      flota: [],
      flotaSelected: null,
      flotas: [],
      vehiculo: [],
      listaIbutton: [],
      credito: false,
      flotaOptions: false,
      bloqueoFormularioVehiculo: false,
      bloqueoFormularioVehiculoIbutton: false,
      showModalFlota: false,
      extra_info: "",
      restricciones: false,
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.clienteService = new ClienteService();
    this.vehiculoService = new VehiculoService();

    this.vehiculo = [];
    this.vehiculo.atributos = {};
    this.flota.operacion = "2";
    this.flota.flota_precio = 0;
  },
  mounted() {
    this.getListaCliente();
    var fecha = new Date();
    $("input[datatype='fecha']").datepicker();
  },
  methods: {
    closeModalFlota() {
      this.showModalFlota = false;
    },

    formaPagoCambiada() {
      if (this.flota.forma_pago == 1 && this.flota.descuento_tipo == 0) {
        this.flota.descuento_tipo = 1;
      }
      this.flota.documento_id = this.flota.forma_pago == 1 ? "24" : "29";
    },

    abrirCambioFlota() {
      this.flotaOptions = !this.flotaOptions;
      this.flotaSelected = null;
    },

    actualizaNuevaFlota() {
      this.flota = this.flotaSelected;
    },

    usarIbutton(text) {
      this.vehiculo.idroom = text;
    },

    
    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          console.log(data);

          this.clientes = [];
          for (var i in data) {
            this.clientes.push({
              id: data[i]._id,
              text: data[i].nombres,
              nit: data[i].identificacion,
              nombres: data[i].nombres,
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    openFlota(object) {
      this.flota = {};
      this.flota.dia = {};
      this.flota.flota_precio = 0;
      this.flota.dia.lunes = true;
      this.flota.dia.martes = true;
      this.flota.dia.miercoles = true;
      this.flota.dia.jueves = true;
      this.flota.dia.viernes = true;
      this.flota.dia.sabado = true;
      this.flota.dia.domingo = true;

      this.showModalFlota = true;
    },

    openVehiculo(flota, vehiculo) {
      this.flota = flota;
      this.flotaOptions = false;
      this.flotaSelected = null;

      if (vehiculo != null) {
        this.vehiculo = vehiculo;
        this.bloqueoFormularioVehiculo = true;
        if (typeof this.vehiculo.atributos == "undefined") {
          this.vehiculo.atributos = {};
        }

        this.vehiculoService
          .getVehiculoId(this.person, this.vehiculo.uniqueid)
          .then((data) => {
            console.log(data);
            this.vehiculo = data;
            this.vehiculo.idroom = data.codigo;

            if (this.vehiculo.idroom == "" || this.vehiculo.idroom == null) {
              this.bloqueoFormularioVehiculoIbutton = false;
            } else {
              this.bloqueoFormularioVehiculoIbutton = true;
            }

            try {
              this.vehiculo.fecha_revision =
                this.vehiculo.fecha_revision.split("T")[0];
            } catch (error) { }
            try {
              this.vehiculo.fecha_mantenimiento =
                this.vehiculo.fecha_mantenimiento.split("T")[0];
            } catch (error) { }

            $("#fecha_revision").val(this.vehiculo.fecha_revision);
            $("#fecha_mantenimiento").val(this.vehiculo.fecha_mantenimiento);

            $("#vehiculo").modal("show");
          })
          .then(() => {
            this.loading = false;
          });
      } else {
        this.bloqueoFormularioVehiculo = false;
        this.bloqueoFormularioVehiculoIbutton = false;
        this.resetDatosVehiculos();
        $("#vehiculo").modal("show");
      }
    },

    resetDatosVehiculos() {
      this.vehiculo = {};
      this.vehiculo._id = 0;
      this.vehiculo.placa = "";
      this.vehiculo.vin = "";
      this.vehiculo.atributos = {};
      this.vehiculo.atributos.propietario_codigo = "";
      this.vehiculo.atributos.propietario_nombre = "";
      this.vehiculo.atributos.marca = "";
      this.vehiculo.atributos.modelo = "";
      this.vehiculo.atributos.potencia = "";
      this.vehiculo.atributos.servicio = "";
      this.vehiculo.fecha_revision = "";
      this.vehiculo.fecha_mantenimiento = "";
    },

    removeVehiculoFromFlota(flota, vehiculo) {
      this.loading = true;
      var request = {};
      request.vehiculo_uniqueid = vehiculo.uniqueid;
      request.flota_uniqueid = flota.uniqueid;
      this.vehiculoService
        .removerVehiculoDeFlota(this.person, request)
        .then((data) => {
          this.actualizaEstructura();
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        });
    },

    inactivaFlota(flota) {
      this.loading = true;
      var request = {};
      request.estado = "I";
      request.uniqueid = flota.uniqueid;
      this.vehiculoService
        .actualizaFlota(this.person, request)
        .then((data) => {
          this.actualizaEstructura();
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        });
    },

    activarFlota(flota) {
      this.loading = true;
      var request = {};
      request.estado = "A";
      request.uniqueid = flota.uniqueid;
      this.vehiculoService
        .actualizaFlota(this.person, request)
        .then((data) => {
          this.actualizaEstructura();
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        });
    },

    agregarVehiculoAFlota() {
      this.vehiculo.fecha_revision = $("#fecha_revision").val().split("T")[0];
      this.vehiculo.fecha_mantenimiento = $("#fecha_mantenimiento")
        .val()
        .split("T")[0];

      if (GLOBAL.COUNTRY == "MX") {
        if (this.vehiculo.fecha_mantenimiento.trim() == "") {
          alert("Verifique la fecha de certificación");
          return false;
        }

        if (this.vehiculo.fecha_revision.trim() == "") {
          alert("Verifique la fecha de proxima revisión");
          return false;
        }
      }

      if (this.vehiculo.placa == null || this.vehiculo.placa.trim() == "") {
        alert("Verifique las placa ingresadas.");
        return false;
      }

      this.vehiculo.placa = this.vehiculo.placa.toUpperCase();

      if (typeof this.vehiculo.idroom != "undefined") {
        this.vehiculo.idroom = this.vehiculo.idroom.toUpperCase();
      }

      var request = {};
      request.uniqueid = this.vehiculo.uniqueid;
      request.empresa_id = this.person.empresa_id;
      request.estado = "A";
      request.placa = this.vehiculo.placa;
      request.codigo = this.vehiculo.idroom;
      request.vin = "";
      request.fecha_mantenimiento = this.vehiculo.fecha_mantenimiento;
      request.fecha_revision = this.vehiculo.fecha_revision;
      request.flota = this.flota.uniqueid;
      request.descuento_tipo = this.flota.descuento_tipo;
      request.descuento_valor = this.flota.descuento_valor;

      request.despacho_veces = this.flota.despacho_veces;
      request.restriccion_dias = this.flota.restriccion_dias;

      request.volumen_despacho = this.flota.volumen_despacho;
      request.importe_despacho = this.flota.importe_despacho;
      request.credito = this.flota.credito;
      request.operacion = this.flota.operacion;

      request.producto_id = 0;

      if (typeof this.vehiculo.atributos == "undefined") {
        request.atributos = {};
      } else {
        request.atributos = this.vehiculo.atributos;
      }

      if (typeof this.vehiculo.capacidad == "undefined") {
        request.capacidad = 0;
      }

      if (typeof this.vehiculo.atributos.propietario_codigo == "undefined") {
        request.atributos.propietario_codigo = "";
      }

      if (typeof this.vehiculo.atributos.propietario_nombre == "undefined") {
        request.atributos.propietario_nombre = "";
      }

      request.registro_empresa_id = this.person.empresa_id;
      request.registro_;
      request.usuario_id = this.person.persona_id;
      request.registro_usuario_id = this.person.persona_id;
      request.tercero_id = this.cliente;

      if (request.placa != "") {
        this.vehiculoService
          .crearVehiculoAgregandoAflota(this.person, request)
          .then((data) => {
            console.log(data);

            if (data.status == 200) {
              this.actualizaEstructura();
              $("#vehiculo").modal("hide");
            } else {
              if (data != null || data.includes("flota_parametros_un")) {
                this.flota.mensaje = "No puede tener dos flotas vacias.";
              } else {
                this.flota.mensaje = "Ha ocurrido un error, intente mas tarde";
              }
            }
          })
          .then(() => {
            this.loading = false;

            this.vehiculo = [];
            this.vehiculo.atributos = {};
            $("#vehiculo").modal("hide");
          });
      } else {
        alert("Se requiere placa para registrar el vehiculo");
      }
    },

    crearFlota() {
      var validacion = "OK";
      if (
        this.flota.documento_id == "undefined" ||
        this.flota.documento_id == null
      ) {
        validacion = "Se requiere el documento que va a entregarse.";
      } else {
        if (this.flota.documento_id == 20 && this.flota.forma_pago == 2) {
          validacion = "Se requiere ajustar el documento de entrega";
        }
      }

      if (this.flota.forma_pago == 1 && this.flota.descuento_tipo == 2) {
        if (
          this.flota.descuento_valor < 0 ||
          this.flota.descuento_valor > 100
        ) {
          validacion = "El valor del porcentaje debe estar entre 0 a 100%";
        }
      }

      if (this.flota.forma_pago == 2 && this.flota.credito_tipo == 0) {
        validacion = "Se requiere ajustar el tipo de credito";
      }

      if (validacion == "OK") {
        this.flota.mensaje = "";

        var request = {};
        request.uniqueid = this.flota.uniqueid;
        request.descripcion = this.flota.descripcion.toUpperCase();

        //Formas de pago: 1 CONTADO, 2 CREDITO
        request.forma_pago = this.flota.forma_pago;
        request.documento_id = this.flota.documento_id;

        if (this.extra_info == 1) {
          this.flota.flota_precio = 0;
        } else if (this.extra_info == 2) {
          this.flota.descuento_tipo = 1;
          this.flota.descuento_valor = 0;
        } else {
          this.flota.flota_precio = 0;
          this.flota.descuento_tipo = 1;
          this.flota.descuento_valor = 0;
        }

        request.flota_precio = this.flota.flota_precio;
        request.descuento_tipo = this.flota.descuento_tipo;
        request.descuento_valor = this.flota.descuento_valor;

        if (this.flota.forma_pago == 1) {
          request.credito_tipo = null;
          request.credito_cupo_maximo = null;
          request.credito_consumo_actual = null;
        } else {
          request.credito_tipo = this.flota.credito_tipo;
          if (request.credito_tipo == 1) {
            request.credito_cupo_maximo = null;
            request.credito_consumo_actual = null;
          } else {
            request.credito_cupo_maximo = this.flota.credito_cupo_maximo;
            request.credito_consumo_actual = this.flota.credito_consumo_actual;
          }
        }

        this.flota.restriccion_dias = "";

        if (this.flota.dia.lunes) {
          this.flota.restriccion_dias += "L";
        }

        if (this.flota.dia.martes) {
          this.flota.restriccion_dias += "M";
        }

        if (this.flota.dia.miercoles) {
          this.flota.restriccion_dias += "X";
        }

        if (this.flota.dia.jueves) {
          this.flota.restriccion_dias += "J";
        }

        if (this.flota.dia.viernes) {
          this.flota.restriccion_dias += "V";
        }

        if (this.flota.dia.sabado) {
          this.flota.restriccion_dias += "S";
        }

        if (this.flota.dia.domingo) {
          this.flota.restriccion_dias += "D";
        }

        request.restriccion_dias = this.flota.restriccion_dias;
        request.restriccion_visitas = this.flota.restriccion_visitas;

        request.volumen_despacho = this.flota.volumen_despacho;
        request.importe_despacho = this.flota.importe_despacho;
        request.fecha_creacion = this.fecha_creacion;
        request.fecha_modificacion = this.fecha_modificacion;
        request.empresa_id = this.person.empresa_id;
        request.activo = "A";
        request.tercero_id = this.cliente;
        request.user_create = this.person.persona_id;
        request.user_update = this.person.persona_id;

        this.loading = true;
        this.flota.mensaje = "";

        console.log(request);
        if (request.uniqueid == null) {
          this.vehiculoService
            .crearFlota(this.person, request)
            .then((data) => {
              console.log(data);

              if (data.status == 200) {
                this.actualizaEstructura();
                this.showModalFlota = false;
              } else {
                if (data != null || data.includes("flota_parametros_un")) {
                  this.flota.mensaje = "No puede tener dos flotas vacias.";
                } else {
                  this.flota.mensaje =
                    "Ha ocurrido un error, intente mas tarde";
                }
              }
            })
            .then(() => {
              this.loading = false;
            });
        } else {
          this.vehiculoService
            .actualizaFlotaFull(this.person, request)
            .then((data) => {
              this.actualizaEstructura();
              this.showModalFlota = false;
            })
            .then(() => {
              this.loading = false;
            });
        }
      } else {
        this.flota.mensaje = validacion;
      }
    },

    actualizaEstructura() {
      this.loading = true;
      var request = {};
      request._id = this.cliente;
      this.vehiculoService
        .getFlotasConVehiculos(this.person, request)
        .then((data) => {
          this.flotas = [];
          for (let i in data) {
            this.flotas[i] = [];
            this.flotas[i].activo = data[i].activo;
            this.flotas[i].uniqueid = data[i].uniqueid;

            this.flotas[i].forma_pago = data[i].forma_pago;
            this.flotas[i].documento_id = data[i].documento_id;

            this.flotas[i].flota_precio = data[i].flota_precio;
            this.flotas[i].descuento_tipo = data[i].descuento_tipo;
            this.flotas[i].descuento_valor = data[i].descuento_valor;

            this.flotas[i].credito_tipo = data[i].credito_tipo;
            this.flotas[i].credito_cupo_maximo = data[i].credito_cupo_maximo;
            this.flotas[i].credito_consumo_actual =
              data[i].credito_consumo_actual;

            this.flotas[i].restriccion_dias = data[i].restriccion_dias;
            this.flotas[i].restriccion_visitas = data[i].restriccion_visitas;

            this.flotas[i].dia = [];

            if (typeof this.flotas[i].restriccion_dias != "undefined") {
              if (this.flotas[i].restriccion_dias.includes("L")) {
                this.flotas[i].dia.lunes = true;
              }
              if (this.flotas[i].restriccion_dias.includes("M")) {
                this.flotas[i].dia.martes = true;
              }
              if (this.flotas[i].restriccion_dias.includes("X")) {
                this.flotas[i].dia.miercoles = true;
              }
              if (this.flotas[i].restriccion_dias.includes("J")) {
                this.flotas[i].dia.jueves = true;
              }
              if (this.flotas[i].restriccion_dias.includes("V")) {
                this.flotas[i].dia.viernes = true;
              }
              if (this.flotas[i].restriccion_dias.includes("S")) {
                this.flotas[i].dia.sabado = true;
              }
              if (this.flotas[i].restriccion_dias.includes("D")) {
                this.flotas[i].dia.domingo = true;
              }
            }

            this.flotas[i].volumen_despacho = data[i].volumen_despacho;
            this.flotas[i].importe_despacho = data[i].importe_despacho;
            this.flotas[i].fecha_creacion = data[i].fecha_creacion;
            this.flotas[i].fecha_modificacion = data[i].fecha_modificacion;
            this.flotas[i].operacion = data[i].operacion;

            if (typeof data[i].descripcion == "undefined") {
              data[i].descripcion = "DEFAULT";
            }
            this.flotas[i].descripcion = data[i].descripcion;

            this.flotas[i]["vehiculos"] = [];
            for (let y in data[i]["vehiculos"]) {
              this.flotas[i]["vehiculos"][y] = [];
              this.flotas[i]["vehiculos"][y].uniqueid =
                data[i]["vehiculos"][y].uniqueid;
              this.flotas[i]["vehiculos"][y].placa =
                data[i]["vehiculos"][y].placa;
              this.flotas[i]["vehiculos"][y].idroom =
                data[i]["vehiculos"][y].identificador;
            }
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    editarFlota(object) {
      if (typeof object == "undefined") {
        this.flota = [];
      } else {
        this.flota = [];
        this.flota.descripcion = object.descripcion;
        this.flota = object;
        this.flota.estado = "A";

        this.extra_info = "0";
        if (this.flota.descuento_valor != 0) {
          this.extra_info = "1";
        }

        if (this.flota.flota_precio != 0) {
          this.extra_info = "2";
        }
      }
      this.showModalFlota = true;
    },

    getVehiculosPorPlaca() {
      this.loading = true;
      var placa = this.vehiculo.placa;
      var identificacion = btoa(GLOBAL.SECRET_KEY + btoa(placa));
      this.vehiculoService
        .getVehiculosPorPlaca(this.person, identificacion)
        .then((data) => {
          if (data.status == 200) {
            this.placa = "";
            this.vehiculo = data.data;

            this.vehiculo.idroom = this.vehiculo.identificador_codigo;
            if (this.vehiculo.idroom == "" || this.vehiculo.idroom == null) {
              this.bloqueoFormularioVehiculoIbutton = false;
            } else {
              this.bloqueoFormularioVehiculoIbutton = true;
            }

            this.bloqueoFormularioVehiculo = true;

            try {
              this.vehiculo.fecha_revision =
                this.vehiculo.fecha_revision.split("T")[0];
              $("#fecha_revision").val(this.vehiculo.fecha_revision);
            } catch (error) { }
            try {
              this.vehiculo.fecha_mantenimiento =
                this.vehiculo.fecha_mantenimiento.split("T")[0];
              $("#fecha_mantenimiento").val(this.vehiculo.fecha_mantenimiento);
            } catch (error) { }
          } else {
            this.resetDatosVehiculos();
            this.vehiculo.placa = placa;
            this.mensaje = "No fué posible realizar la operación";
            this.bloqueoFormularioVehiculo = false;
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.flotas {
  width: 400px;
}
</style>
